import * as React from "react";
import { Paper, Grid, Typography, createStyles, withStyles } from "@material-ui/core";
import { getDate, isSameMonth, isToday, format, isWithinInterval } from "date-fns";
import { chunks, getDaysInMonth, isStartOfRange, isEndOfRange, inDateRange, isRangeSameDay } from "../utils";
import Header from "./Header";
import Day from "./Day";
import { NavigationAction } from "../types";
var WEEK_DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
var styles = function (_) {
    return createStyles({
        root: {
            width: 290
        },
        weekDaysContainer: {
            marginTop: 10,
            paddingLeft: 30,
            paddingRight: 30
        },
        daysContainer: {
            paddingLeft: 15,
            paddingRight: 15,
            marginTop: 15,
            marginBottom: 20
        }
    });
};
var Month = function (props) {
    var classes = props.classes, helpers = props.helpers, handlers = props.handlers, date = props.value, dateRange = props.dateRange, marker = props.marker, setDate = props.setValue, minDate = props.minDate, maxDate = props.maxDate, _a = props.weekDays, weekDays = _a === void 0 ? WEEK_DAYS : _a, months = props.months;
    var _b = props.navState, back = _b[0], forward = _b[1];
    return (React.createElement(Paper, { square: true, elevation: 0, className: classes.root },
        React.createElement(Grid, { container: true },
            React.createElement(Header, { date: date, setDate: setDate, nextDisabled: !forward, prevDisabled: !back, onClickPrevious: function () {
                    return handlers.onMonthNavigate(marker, NavigationAction.Previous);
                }, onClickNext: function () { return handlers.onMonthNavigate(marker, NavigationAction.Next); }, months: months }),
            React.createElement(Grid, { item: true, container: true, direction: "row", justify: "space-between", className: classes.weekDaysContainer }, weekDays.map(function (day) { return (React.createElement(Typography, { color: "textSecondary", key: day, variant: "caption" }, day)); })),
            React.createElement(Grid, { item: true, container: true, direction: "column", justify: "space-between", className: classes.daysContainer }, chunks(getDaysInMonth(date), 7).map(function (week, idx) { return (React.createElement(Grid, { key: idx, container: true, direction: "row", justify: "center" }, week.map(function (day) {
                var isStart = isStartOfRange(dateRange, day);
                var isEnd = isEndOfRange(dateRange, day);
                var isRangeOneDay = isRangeSameDay(dateRange);
                var highlighted = inDateRange(dateRange, day) || helpers.inHoverRange(day);
                return (React.createElement(Day, { key: format(day, "MM-dd-yyyy"), filled: isStart || isEnd, outlined: isToday(day), highlighted: highlighted && !isRangeOneDay, disabled: !isSameMonth(date, day) ||
                        !isWithinInterval(day, { start: minDate, end: maxDate }), startOfRange: isStart && !isRangeOneDay, endOfRange: isEnd && !isRangeOneDay, onClick: function () { return handlers.onDayClick(day); }, onHover: function () { return handlers.onDayHover(day); }, value: getDate(day) }));
            }))); })))));
};
export default withStyles(styles)(Month);
//# sourceMappingURL=Month.js.map